export const TITLE = "Login";

export const CPF_PATTERN = "[0-9][0-9][0-9]\.?[0-9][0-9][0-9]\.?[0-9][0-9][0-9]\-?[0-9][0-9]";
